var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogoColorPrimary = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 40,
    fill: "none",
    viewBox: "0 0 139 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77.71,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#DEDEDE",
    rx: 9.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E55107",
    d: "M92.204 30.994V11.535h2.75v19.459h-2.75zm0-23.082v-2.75h2.75v2.75h-2.75zM99.57 30.994v-15.4c0-1.117.39-2.068 1.173-2.85.806-.806 1.767-1.208 2.886-1.208h10.936v2.75h-10.936c-.358 0-.671.135-.94.403-.246.246-.369.548-.369.906v15.399h-2.75zM121.183 30.994c-1.118 0-2.08-.392-2.885-1.175-.783-.805-1.174-1.767-1.174-2.885V19.89h17.042v-4.294c0-.358-.134-.66-.402-.906-.246-.268-.548-.402-.906-.402h-15.734v-2.752h15.734c1.14 0 2.102.403 2.885 1.208.805.783 1.208 1.734 1.208 2.852v15.399h-15.768zm0-2.751h12.983V22.64h-14.291v4.294c0 .358.123.671.369.94.268.246.581.369.939.369zM78.317 18.916l6.341-7.38h3.59v.033l-8.119 9.528 8.152 9.863v.034h-3.623l-6.34-7.784v-4.294z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#908F8E",
    d: "M68.387 30.96v.034h3.623l6.307-7.784v-4.294l-6.307-7.38h-3.623v.033l8.119 9.528-8.119 9.863z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoColorPrimary, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Logo_Color_Primary.25d8078e.svg";
export { ForwardRef as ReactComponent };